import React from 'react';
import ReactDOM from 'react-dom';
import queryString from 'query-string';
import { getContext } from './commons/services/utils';
import apps from './apps';

// set CUSTOM_INSTANCE if you want to test premium features
const CUSTOM_INSTANCE = null;

let context = getContext(window.location.search);

if (
  CUSTOM_INSTANCE &&
  window.history.pushState &&
  context.instance !== CUSTOM_INSTANCE
) {
  context = Object.assign({}, context, { instance: CUSTOM_INSTANCE });

  const newurl = window.location.protocol +
    '//' +
    window.location.host +
    window.location.pathname +
    '?' +
    queryString.stringify(context);

  window.history.pushState({ path: newurl }, '', newurl);
  window.location.reload();
}

if (context.app in apps) {
  const App = apps[context.app];
  ReactDOM.render(<App context={context} />, document.getElementById('root'));
}



// WEBPACK FOOTER //
// ./src/index.js